// extracted by mini-css-extract-plugin
export var age = "employee-module--age--1uPms";
export var blu = "employee-module--blu--TQ+ts";
export var button = "employee-module--button--RfIh5";
export var container = "employee-module--container---QO1b";
export var content = "employee-module--content--hFyMm";
export var employeesWrap = "employee-module--employees-wrap--1kKIk";
export var enrollmentWrap = "employee-module--enrollment-wrap--he6cT";
export var grid2 = "employee-module--grid-2--WzgJ-";
export var heading = "employee-module--heading--ETtgh";
export var sliderImg = "employee-module--slider-img--NTMtv";
export var sticky = "employee-module--sticky--01hof";
export var subMenu = "employee-module--sub-menu--6uIMf";